import React from 'react';
import Toggle from 'src/components/Toggle';
import {
  SystemLevelNotification,
  NotificationChannel,
} from 'src/pages/Settings/CustomHooks/useSystemNotifications';
import './SystemNotificationRow.scss';

interface SystemNotificationRowProps {
  notification: SystemLevelNotification;
  onToggleChannel: (channel: NotificationChannel) => void;
}

const SystemNotificationRow = ({
  notification,
  onToggleChannel,
}: SystemNotificationRowProps) => (
  <div className="system-notification-row">
    <div className="row-info">
      <span className="row-name">{notification.name}</span>
      {notification.description && (
        <span className="row-description">{notification.description}</span>
      )}
    </div>

    <div className="row-channels">
      <div className="channel">
        <span className="channel-label">Internal</span>
        <Toggle
          label=""
          value={notification.groups.allowInternal}
          onToggle={() => onToggleChannel('allowInternal')}
        />
      </div>

      <div className="channel-divider" />

      <div className="channel">
        <span className="channel-label">External</span>
        <Toggle
          label=""
          value={notification.groups.allowExternal}
          onToggle={() => onToggleChannel('allowExternal')}
        />
      </div>
    </div>
  </div>
);

export default SystemNotificationRow;
